import { GraphQLClient } from 'graphql-request';
import store from 'src/redux/config/configureStore';
import { UserRolesEnum } from 'src/types.d';
import { handleErrorGraphql } from './queries/handleError';

export const graphQLRequest = async (
  token: string,
  client: GraphQLClient,
  query: string,
  params?: any,
  role?: UserRolesEnum,
) => {
  const headers = getHeaders(process.env.REACT_APP_TOKEN ?? token, role);
  try {
    return await client.request(query, params, headers);
  } catch (err) {
    return handleErrorGraphql(err);
  }
};

/**
 * Gets the headers for the request
 * @param token Given Auth token
 * @param role The role of the user
 * @returns Headers for the request
 */
function getHeaders(token: string, role?: UserRolesEnum) {
  // if we are in a view as state we want the graphql requests to have the operator header other wise take the default
  const viewAsEmail = store.getState().investor.viewAsEmail;
  
  return {
    authorization: `Bearer ${token}`,
    role: viewAsEmail ? UserRolesEnum.operator : role || process.env.REACT_APP_TYPE,
  };
}
